<template>
  <div class="info wrapper">
    <header class="header">
      <img src="@/assets/background.jpg" alt class="bg" />
      <div class="header__about">
        <div class="logo-wrapper">
          <img class="logo" :src="image" alt />
        </div>
        <!-- <img class="logo" src="https://scontent-frt3-1.cdninstagram.com/vp/2d48f5a7fc71be53874c43136589dac8/5DAE4034/t51.2885-19/s320x320/25007227_1012511705553857_6473910071909679104_n.jpg?_nc_ht=scontent-frt3-1.cdninstagram.com" alt> -->
        <span></span>
        <h1>{{ about.competition }}</h1>
        <h2>{{ about.location }}, {{ about.date }}</h2>
        <router-link to="/qualifications" exact tag="button" v-if="!resultsDisabled" class="btn"
          >Wyniki na żywo</router-link
        >
      </div>
    </header>

    <div class="main">
      <div class="wysiwyg-content" v-html="info"></div>
    </div>
  </div>
</template>

<script>
import marked from 'marked'

export default {
  name: 'info',
  computed: {
    image() {
      return this.$store.state.image
    },
    about() {
      return this.$store.state.about
    },
    info() {
      return (
        marked(this.$store.state.cache.live.info || '') ||
        '<br><h4>Organizator nie umieścił żadnych informacji o wydarzeniu</h4>'
      )
    },
    resultsDisabled() {
      return this.$store.state.cache.live.lockedTabs.indexOf(2) > -1
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
@import '@/scss/_mixins.scss';

.header {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 3px 3px 4px #eee;
  position: relative;

  .bg {
    width: 100%;
    height: 300px;
    object-fit: cover;
    object-position: center;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    @media #{$media-lg} {
      height: 220px;
    }

    @media #{$media-md} {
      height: 180px;
    }

    @media #{$media-sm} {
      height: 120px;
    }
  }

  &__about {
    display: grid;
    grid-template-columns: 128px 1fr 120px;
    grid-template-rows: 64px auto auto;
    grid-gap: 0 16px;
    text-align: left;
    width: 95%;
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;
    z-index: 1000;
    padding-top: 236px;
    padding-bottom: 8px;

    @media #{$media-lg} {
      padding-top: calc(220px - 64px);
    }

    @media #{$media-md} {
      grid-template-rows: 70px auto auto;
      grid-template-columns: 72px 1fr 120px;
      padding-top: calc(180px - 64px);
    }

    @media #{$media-sm} {
      padding-top: calc(120px - 64px);
    }

    .logo-wrapper {
      width: 128px;
      height: 128px;
      padding: 21px;
      border-radius: 10px;
      border-top-left-radius: 50%;
      border-top-right-radius: 50%;
      background: #fff;
      box-sizing: border-box;
      grid-row: 1/4;

      @media #{$media-md} {
        width: 72px;
        height: 72px;
        grid-column: auto;
        grid-row: auto;
        padding: 10px;
      }
    }

    .logo {
      width: 100%;
      -o-object-fit: cover;
      object-fit: cover;
      box-sizing: border-box;
    }

    h1 {
      margin: 0;
      font-size: 1.4em;
      align-self: end;
      grid-row: 2/3;
      grid-column: 2/4;

      @media #{$media-md} {
        font-size: 1.1em;
        grid-column: 1/4;
        margin-top: 10px;
      }
    }

    h2 {
      margin: 0;
      font-size: 0.8em;
      grid-row: 3/4;
      grid-column: 2/4;

      @media #{$media-md} {
        grid-column: 1/4;
      }
    }

    .btn {
      grid-column: 3/4;
      grid-row: 1/2;
      justify-self: center;
      align-self: center;
      margin-top: 10px;
      color: #fff;

      @media #{$media-md} {
        grid-column: auto;
        grid-row: auto;
      }
    }
  }
}
</style>
